var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('brace',{staticClass:"kbet-editor",staticStyle:{"height":"90vh"},attrs:{"mode":'json'},on:{"code-change":_vm.onEditorCodeChange,"setHandler":function (h) {
						_vm.editorHandler = h;
					}}})],1)],1),(
			_vm.dataProp.renderMode != 'parsed' &&
				(_vm.selectedFile.extension == 'pdf' ||
					/xl/gi.test(_vm.selectedFile.extension))
		)?_c('v-btn',{attrs:{"color":"blue darken-1","small":"","absolute":"","top":"","right":"","fab":""},on:{"click":_vm.jsonToText}},[_c('v-icon',[_vm._v(_vm._s(_vm.textMode ? 'code' : 'text_fields'))])],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }